import React from "react";
import {
  Box,
  HStack,
  VStack,
  Text,
  Divider,
  Button,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import {
  FiClock,
  FiFileText,
  FiTrash2,
  FiDollarSign,
  FiTrendingDown,
  FiGrid,
  FiCalendar,
  FiUserCheck,
  FiSettings,
  FiLogOut,
} from "react-icons/fi";
import ColorModeToggle from "./ColorModeToggle";

export default function Sidebar({
  page,
  onNavigate,
  userName,
  onLogout,
  canAdmin,
  userRole,
}) {
  const activeBg = useColorModeValue("rgba(45,127,249,.12)", "rgba(45,127,249,.18)");
  const hoverBg = useColorModeValue("rgba(45,127,249,.10)", "rgba(45,127,249,.12)");

  // Define allowed keys for staff
  const staffAllowed = [
    "Clockins",
    "ZReport",
    "ZReportNext",
   "ZReport_Advanced",
   "Suppliers",
   "Wastage",
    "Expenses",
    "Debts",
    "StaffRota",
    // Add or remove keys as needed
  ];

  const items = [
    { key: "Clockins", label: "Clock-Ins", icon: FiClock },
    { key: "ZReport", label: "Store Z-Report Old", icon: FiFileText },
    { key: "ZReportNext", label: "Store Z-Report New", icon: FiFileText },
    { key: "ZReport_Advanced", label: "Store Z-Report Uploader", icon: FiFileText },
    { key: "Suppliers", label: "Store Suppliers", icon: FiFileText },
    { key: "Wastage", label: "Wastage", icon: FiTrash2 },
    { key: "Expenses", label: "Expenses", icon: FiDollarSign },
    { key: "Debts", label: "Debts", icon: FiTrendingDown },
    { key: "Dashboard", label: "Dashboard", icon: FiGrid },
    { key: "StaffRota", label: "MyRota", icon: FiCalendar },
    { key: "Rota", label: "Weekly Rota Admin", icon: FiUserCheck },
    { key: "RotaAdmin", label: "RotaAdmin", icon: FiCalendar },
    ...(canAdmin ? [{ key: "Admin", label: "Admin Panel", icon: FiSettings }] : []),
  ];

  // Filter items for staff
  const filteredItems =
    userRole === "staff"
      ? items.filter((item) => staffAllowed.includes(item.key))
      : items;

  return (
    <Box
      as="nav"
      w={{ base: "100%", md: "240px" }}
      bg="panelAlt"
      borderRight="1px solid"
      borderColor="divider"
      minH="100vh"
      p={3}
      className="sidebar"
    >
      <HStack justify="space-between" mb={3}>
        <Text fontWeight="800">OneStop Admin</Text>
        <ColorModeToggle />
      </HStack>

      <Text fontSize="sm" color="textMuted" mb={2}>
        Logged in as <b>{userName}</b>
      </Text>

      <Text fontSize="xs" color="textMuted" mt={3} mb={1}>
        Main Menu
      </Text>

      <VStack spacing={1} align="stretch">
        {filteredItems.map(({ key, label, icon }) => (
          <HStack
            key={key}
            onClick={() => onNavigate(key)}
            px={3}
            py={2.5}
            borderRadius="10px"
            _hover={{ bg: hoverBg }}
            bg={page === key ? activeBg : "transparent"}
            cursor="pointer"
          >
            <Icon as={icon} boxSize={4} />
            <Text fontSize="sm" fontWeight={page === key ? 700 : 500}>
              {label}
            </Text>
          </HStack>
        ))}
      </VStack>

      <Divider my={4} />
      <Button
        leftIcon={<FiLogOut />}
        colorScheme="red"
        w="full"
        onClick={onLogout}
        bg={useColorModeValue("red.500", "red.400")}
        color="white"
        _hover={{
          bg: useColorModeValue("red.600", "red.500"),
        }}
      >
        Log out
      </Button>
    </Box>
  );
}